import { __assign, __generator } from "tslib";
import axios from 'axios';
import { call, select } from 'redux-saga/effects';
import { ConfigSelectors } from '../config';
import ddt from '@wix/da-ddt';
import { CANCEL } from 'redux-saga';
import { getPublicSession } from '../publicSession/selectors';
var CANONICAL_XHR_ENDPOINT = 'https://www.deviantart.com/_napi/shared_api/';
var LOCAL_XHR_ENDPOINT = 'https://www.deviantart.lan/_napi/shared_api/';
function getFakeResponse(response) {
    if (process.env.NODE_ENV === 'test') {
        return response;
    }
    return new Promise(function (resolve) {
        setTimeout(function () { return resolve(response); }, 1000);
    });
}
function getApiResponse(options) {
    var cancelTokenSource = axios.CancelToken.source();
    var promise = axios
        .request(options.enableCancellation
        ? __assign(__assign({}, options), { cancelToken: cancelTokenSource.token }) : options)
        .then(function (response) {
        return response.data;
    })
        .catch(function () {
        return false;
    });
    // redux saga calls this special prop when it cancel the outer saga E.g. takeLatest
    if (options.enableCancellation) {
        promise[CANCEL] = function () { return cancelTokenSource.cancel(); };
    }
    return promise;
}
export function isApiError(response) {
    return response.error;
}
export function request(options, fakeResponse) {
    var _a, _b, _c, withCreds, session, result, doFake;
    var _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                if (!(options.baseURL === undefined)) return [3 /*break*/, 3];
                if (!(process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm')) return [3 /*break*/, 2];
                _a = options;
                return [4 /*yield*/, select(ConfigSelectors.key('sharedApiBasePath'))];
            case 1:
                _a.baseURL = _e.sent();
                return [3 /*break*/, 3];
            case 2:
                if (window['__XHR_LOCAL__']) {
                    options.baseURL = LOCAL_XHR_ENDPOINT;
                    // Production goes to the xhr server
                }
                else {
                    options.baseURL = CANONICAL_XHR_ENDPOINT;
                }
                _e.label = 3;
            case 3:
                if (!(options.method && options.method.toLowerCase() === 'post')) return [3 /*break*/, 5];
                if (options.data === undefined) {
                    options.data = {};
                }
                _b = options.data;
                _c = 'csrf_token';
                return [4 /*yield*/, select(ConfigSelectors.key('csrfToken'))];
            case 4:
                _b[_c] = _e.sent();
                _e.label = 5;
            case 5: return [4 /*yield*/, select(ConfigSelectors.key('withCredentials'))];
            case 6:
                withCreds = _e.sent();
                if (withCreds) {
                    options.withCredentials = true;
                }
                return [4 /*yield*/, select(getPublicSession)];
            case 7:
                session = _e.sent();
                if ((_d = session === null || session === void 0 ? void 0 : session.device) === null || _d === void 0 ? void 0 : _d.supportsWebp) {
                    options.headers = __assign(__assign({}, options.headers), { Accept: 'application/json, text/plain, image/webp, */*' });
                }
                if (!(process.env.NODE_ENV !== 'production')) return [3 /*break*/, 10];
                if (!(fakeResponse !== undefined)) return [3 /*break*/, 10];
                return [4 /*yield*/, select(ConfigSelectors.key('fakeApiRequests'))];
            case 8:
                doFake = _e.sent();
                if (!doFake) return [3 /*break*/, 10];
                ddt.log('saga', "Faked XHR for: ".concat(options.url), options, fakeResponse(options));
                return [4 /*yield*/, call(getFakeResponse, fakeResponse(options))];
            case 9:
                result = _e.sent();
                return [2 /*return*/, result];
            case 10: return [4 /*yield*/, call(getApiResponse, options)];
            case 11:
                result = _e.sent();
                return [2 /*return*/, result];
        }
    });
}
//# sourceMappingURL=request.js.map